import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { AuthSelector, CustomerManagementSelector, JurisdictionSelector } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { DateFormat, DateService } from "@obg/ngx.global";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { LastLoginTimestamp } from "./last-login.model";

@Injectable({
	providedIn: "root",
})
export class LastLoginService {
	constructor(
		private store: Store<CoreContentState>,
		private dateService: DateService
	) {}

	getIsAuthenticated$() {
		return this.store.select(AuthSelector.isAuthenticated);
	}

	getJurisdiction$() {
		return this.store.select(JurisdictionSelector.get);
	}

	getLastLoginTimestamp$(): Observable<LastLoginTimestamp> {
		return this.store.pipe(
			select(CustomerManagementSelector.getCustomer),
			map((customer) => {
				if (!customer || customer.lastLogins.length < 1) {
					return { undefined };
				}

				const timestamp = customer.lastLogins[1].timestamp;

				return {
					date: this.dateService.format(timestamp, DateFormat.ShortDate) as string,
					time: this.dateService.format(timestamp, DateFormat.ShortTime) as string,
				};
			})
		);
	}
}
